import type { Localization } from './types'

import { Operators } from './constants'

export const localization: Localization = {
	getCombinatorLabel(joinOperator: 'and' | 'or') {
		return joinOperator
	},
	getWhereLabel() {
		return 'Where'
	},
	getOperatorLabel(operatorKey: any) {
		return defaultOperatorsNameMapping[operatorKey] || operatorKey
	},
	getSelectValuePlaceholder() {
		return 'Select a value'
	},
	getEnterValuePlaceholder() {
		return 'Enter a value'
	},
	getFieldPlaceholder() {
		return 'Find a field'
	},
	getOperationPlaceholder() {
		return 'Find an operator'
	},
	getDuplicatedRowsMessage() {
		return 'Conditions conflict! Only the last duplicate filter will be applied.'
	},
	getSearchPlaceholder() {
		return 'Search options...'
	},
	getNoOptionsMessage() {
		return 'No options found'
	},
	getSelectAllMessage() {
		return 'Select all'
	},
	getReferenceTypeField() {
		return 'Field'
	},
	getReferenceTypeValue() {
		return 'Value'
	},
	getSelectedCountMessage(count: number) {
		return `Selected (${count})`
	},
}
const defaultOperatorsNameMapping: Record<string, string> = {
	[Operators.DATE_AFTER]: 'after',
	[Operators.DATE_BEFORE]: 'before',
	[Operators.DATE_AT]: 'at',
	[Operators.DATE_BETWEEN]: 'between',
	[Operators.CONTAINS]: 'contains',
	[Operators.NOT_CONTAINS]: 'not contains',
	[Operators.IS]: 'is',
	[Operators.IN]: 'in',
	[Operators.NOT_IN]: 'not in',
	[Operators.IS_NOT]: 'is not',
	[Operators.IS_EMPTY]: 'is empty',
	[Operators.IS_NOT_EMPTY]: 'is not empty',
	[Operators.GT]: '>',
	[Operators.LT]: '<',
	[Operators.EQ]: '=',
	[Operators.LTE]: '≤',
	[Operators.GTE]: '≥',
	[Operators.NE]: '≠',
	[Operators.BL]: '=',
	[Operators.ANY_OF]: 'any of',
	[Operators.ALL_OF]: 'all of',
	[Operators.EXACT]: 'is exactly',
	[Operators.NONE_OF]: 'is none of',
	[Operators.BETWEEN]: 'between',
	[Operators.DESCENDANT_OF]: 'descendant of',
}
